<template>
  <div align="Left">
    <md-card id="screenings" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <i class="material-icons">visibility</i>
        </div>
        <h4 class="title">Available Screenings [ Admin ]</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-right" style="padding: 0;">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm">
              <label>Search</label>
              <md-input v-model="searchTxt" />
            </md-field>
          </div>

          <!-- FILTER -->
          <!-- <div class="md-layout-item md-size-10">
            <drop-down direction="down">
              <md-button slot="title" class="md-button md-primary md-sm md-block dropdown-toggle"
                data-toggle="dropdown" >Filter</md-button>

              <ul class="dropdown-menu dropdown-menu">
                <li v-for="item in filterItems" :key="item.id"
                  :class="selectedFilter === item.id ? 'selected-filter-item' : null" @click="filterSelect(item)">
                  {{ item.name }}
                  <br>
                </li>
              </ul>
            </drop-down>
          </div> -->
          <!-- <div class="md-layout-item md-size-20">
            <md-button slot="title" class="md-button md-primary md-sm md-block" disabled @click="deleteAllTestPatients"
              >Delete ALL Test Patients</md-button
            >
          </div> -->
          <!-- SPACER -->
          <!-- <div class="md-layout-item md-size-10"></div> -->
        </div>

        <hr v-if="!isLoading" />
      </md-card-header>

      <md-card-content style="padding-top: 0px;" v-if="!isLoading">
        <md-table
          v-model="filteredScreenings"
          class="table-shopping table-striped table-hover"
          @md-selected="getSelected"
          @click.native="labelSort($event, false)"
        >
          <md-table-row>
            <md-table-empty-state
              :md-description="`No screenings found for this time frame or search criteria`"
              md-label="No screenings found"
            />
          </md-table-row>
          <md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single" @click="gotoEval(item)">
            <md-table-cell></md-table-cell>

            <md-table-cell
              md-label="date"
              style="margin-top: 9px; margin-bottom: 9px; padding-top: 9px; padding-bottom: 9px;"
            >
              <span style="font-size: .82rem; font-weight:500;"
                ><b>{{ item.Date.split("T")[0].replace(/-/g, "/") }}</b></span
              >
              <br />
              <small style="color: green;"> {{ item.packageID.slice(0, 11).toUpperCase() }}</small>
            </md-table-cell>

            <md-table-cell md-label="name" style="color: #0000f3; font-size: 1.07rem;">
              <span>{{ item.firstName }}</span> <br />
              <small style="font-size: .80rem; color: darkgray; "> {{ item.Email }} </small>
            </md-table-cell>

            <!-- <md-table-cell v-if="FL" md-label="name" style="color: #0000f3; font-size: 1.05rem;"> {{ item.firstName}} <br
              <small style="font-size: .80rem; color:darkgray;"> {{ item.Email }} </small>
            </md-table-cell> -->
            <!-- <md-table-cell v-else md-label="name">{{item.lastName }} <br>
              <small style="font-size: .80rem; color:darkgray;"> {{ item.Email }} </small>
            </md-table-cell> -->

            <md-table-cell md-label="gender">{{ item.Gender }}</md-table-cell>
            <md-table-cell md-label="Globe">{{ item.Device }}</md-table-cell>
            <md-table-cell md-label="city">{{ item.city }}</md-table-cell>
            <md-table-cell md-label="technician">{{ item.Technician }}</md-table-cell>
            <md-table-cell md-label="start">
              {{ item.Date.slice(-8, -3)
              }}<!--<small>{{ item.start }}</small>-->
            </md-table-cell>
            <md-table-cell md-label="duration"> {{ item.Duration }} &nbsp; min </md-table-cell>

            <md-table-cell />
          </md-table-row>
        </md-table>

        <div class="table table-stats">
          <div class="text-right">
            <hr />
            <div class>
              <p class="card-category">
                Showing &nbsp;<b
                  ><u>{{ total }}</u></b
                >&nbsp;
                <!--{{ Results_Qualifier }}-->
              </p>
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>

    <loader :is-visible="isLoading" />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Fuse from "fuse.js"
import swal from "sweetalert2"
import { truncate } from "fs"
import moment from "moment"
import loader from "@/components/GlobeChek/loader.vue"

export default {
  components: {
    loader
  },
  data() {
    return {
      //Screenings: [],
      isLoading: false,
      axiosInterceptor: null,

      payload: {
        kioskID: "0-000",
        hold: false,
        filter: "m12" //d-day, m-month, w-week, y-year, a-all
      },

      selectedFilter: 4,
      filterItems: [
        { id: 1, val: "d", name: "Day", disp: "screens in the past Day" },
        { id: 2, val: "w", name: "Week", disp: "screens in the past Week" },
        { id: 3, val: "m", name: "Month", disp: "screens in the past Month" },
        {
          id: 4,
          val: "m3",
          name: "3-Months",
          disp: "screens in the past 3-Months"
        },
        {
          id: 5,
          val: "m6",
          name: "6-Months",
          disp: "screens in the past 6-Months"
        },
        { id: 6, val: "y", name: "Year", disp: "screens in the past Year" },
        { id: 7, val: null, name: "All", disp: "screens in Total" }
      ],

      status: false,
      sortBy: "name",
      sortDirection: "ASC",
      search: "",
      FL: true,
      orderAsc: false,
      API_SERVICE: process.env.VUE_APP_URL,
      selected: {},
      searchTxt: null,
      currentSort: "name",
      currentSortOrder: "asc",
      footerTable: ["First", "Last", "Email", "Tech", "Globe", "Date"],
      searchQuery: "",
      propsToSearch: ["first", "last", "email", "date"],
      tableData: [],
      searchedData: [],
      fuseSearch: null
    }
  },

  watch: {
    //NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
    //@param value of the query
    searchQuery(value) {
      let result = this.tableData
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery)
      }
      this.searchedData = result
    }
  },
  created: function() {},
  mounted: function() {
    this.enableInterceptor()
    this.$store.dispatch("loadScreenings", this.payload)
    this.tableData = this.screenings

    //Initialize Fuse Search
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["first", "email"],
      threshold: 0.3
    })
  },
  updated: function() {},
  destroyed: function() {},

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters(["screenings", "screeningID"]),
    // Returns a page from the searched data or the whole data. Search is performed in the watch section below

    filteredScreenings() {
      // return this.screenings;

      if (this.searchTxt) {
        var self = this
        var restul_A = this.screenings.filter(function(a) {
          // Convert null values to '' so toLowerCase() will work on compare
          a.firstName = a.firstName ? a.firstName : ""
          a.lastName = a.lastName ? a.lastName : ""
          a.packageID = a.packageID ? a.packageID : ""
          a.Email = a.Email ? a.Email : ""
          a.Gender = a.Gender ? a.Gender : ""
          a.Technician = a.Technician ? a.Technician : ""
          a.Device = a.Device ? a.Device : ""
          a.city = a.city ? a.city : ""
          a.Date = a.Date ? a.Date : ""

          return (
            a.firstName.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.lastName.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.packageID.slice(0, 11).includes(self.searchTxt.toLowerCase()) ||
            a.Email.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Gender.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Technician.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Device.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.city.toLowerCase().includes(self.searchTxt.toLowerCase()) ||
            a.Date.slice(-8, -3).includes(self.searchTxt.toLowerCase())
          )
        })
        return restul_A
      } else {
        return this.screenings
      }
    },

    Results_Qualifier() {
      return this.filterItems[this.selectedFilter - 1].disp
    },

    total() {
      return this.filteredScreenings.length > 0 ? this.filteredScreenings.length : this.filteredScreenings.length
    }
  },

  methods: {
    labelSort(type, menu) {
      let sort = menu ? type : event.target.textContent.trim()
      this.sortBy = sort

      // alert(sort)

      if (sort == this.sortBy) {
        this.orderAsc = !this.orderAsc
      } else {
        this.orderAsc = true
      }

      switch (sort.toLowerCase()) {
        case "name":
          this.screensByLastfirst(this.orderAsc)
          break

        case "date":
          this.screensByDateTime(this.orderAsc)
          break

        case "technician":
          this.screensByTechnician(this.orderAsc)
          break

        case "globe":
          this.screensByGlobe(this.orderAsc)
          break

        case "city":
          this.screensByCity(this.orderAsc)
          break

        case "gender":
          this.screensByGender(this.orderAsc)
          break

        default:
          return null
      }
    },
    screensByLastfirst(order) {
      let newScreenings = this.screenings.slice().sort(function(a, b) {
        if (order) {
          return a.lastName > b.lastName ? 1 : -1
        } else {
          return a.lastName < b.lastName ? 1 : -1
        }
      })
      this.$store.dispatch("sortScreenings", newScreenings)
    },
    screensByDateTime(order) {
      let newScreenings = this.screenings.slice().sort(function(a, b) {
        if (order) {
          return new moment(a.Date).format("YYYYMMDD") > new moment(b.Date).format("YYYYMMDD") ? 1 : -1
        } else {
          return new moment(a.Date).format("YYYYMMDD") < new moment(b.Date).format("YYYYMMDD") ? 1 : -1
        }
      })
      this.$store.dispatch("sortScreenings", newScreenings)
    },
    screensByTechnician(order) {
      let newScreenings = this.screenings.slice().sort(function(a, b) {
        if (order) {
          return a.Technician.toLowerCase() > b.Technician.toLowerCase() ? 1 : -1
        } else {
          return a.Technician.toLowerCase() < b.Technician.toLowerCase() ? 1 : -1
        }
      })
      this.$store.dispatch("sortScreenings", newScreenings)
    },
    screensByGlobe(order) {
      let newScreenings = this.screenings.slice().sort(function(a, b) {
        if (order) {
          return a.Device > b.Device ? 1 : -1
        } else {
          return a.Device < b.Device ? 1 : -1
        }
      })
      this.$store.dispatch("sortScreenings", newScreenings)
    },
    screensByCity(order) {
      let newScreenings = this.screenings.slice().sort(function(a, b) {
        if (order) {
          return a.city.toLowerCase() > b.city.toLowerCase() ? 1 : -1
        } else {
          return a.city.toLowerCase() < b.city.toLowerCase() ? 1 : -1
        }
      })
      this.$store.dispatch("sortScreenings", newScreenings)
    },
    screensByGender(order) {
      let newScreenings = this.screenings.slice().sort(function(a, b) {
        if (order) {
          return a.Gender > b.Gender ? 1 : -1
        } else {
          return a.Gender < b.Gender ? 1 : -1
        }
      })
      this.$store.dispatch("sortScreenings", newScreenings)
    },
    filterSelect(item) {
      this.selectedFilter = item.id
      this.payload.filter = item.val
      this.$store.dispatch("loadScreenings", this.payload)
      this.tableData = this.screenings
    },
    refreshPage() {
      this.$router.go()
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    getSelected(item) {
      this.selected = item
    },

    gotoEval(item) {
      this.selected = item
      sessionStorage.setItem("screeningID", item.packageID)
      sessionStorage.setItem("storageID", item.screenID)
      sessionStorage.setItem("OrgID", item.orgID)
      sessionStorage.setItem("OrgCode", item.orgCode)
      sessionStorage.setItem("OrgBusiness", item.orgBusiness)
      this.$store.dispatch("updateScreeningStatus", item.status)
      sessionStorage.setItem("patientUserID", item.patientUserID) // "storageID" is the screeningID in the new DB. Whereas previously screeningID=packageID

      //Keep track of which screenings are in-progress to save FDRs upon reload)
      var ongoingScreenings = JSON.parse(localStorage.getItem("ongoingScreenings"))
      if (!ongoingScreenings) {
        ongoingScreenings = [item.packageID]
      } else if (!ongoingScreenings.includes(item.packageID)) {
        ongoingScreenings.push(item.packageID)
      }
      localStorage.setItem("ongoingScreenings", JSON.stringify(ongoingScreenings))
      let fdr = {
        External: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Corneal: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Nerve: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Lens: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Fundus: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Anterior: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        },
        Macular: {
          findingsOS: [],
          findingsOD: [],
          diagnosesOS: [],
          diagnosesOD: [],
          recommendOS: [],
          recommendOD: []
        }
      }


      //load Images for selected Eval then goto Eval page
      //this.$store.dispatch("loadImages", sessionStorage.getItem("storageID"));
      this.$router.push("/portal/admin/evaluation")
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy])
        }
        return b[sortBy].localeCompare(a[sortBy])
      })
    },

    handleLike(item) {
      swal({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success"
      })
    },
    handleEdit(item) {
      swal({
        title: `You want to edit ${item.name}`,
        buttonsStyling: false,
        confirmButtonClass: "md-button md-info"
      })
    },
    handleDelete(item) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(item)
          swal({
            title: "Deleted!",
            text: `You deleted ${item.name}`,
            type: "success",
            confirmButtonClass: "md-button md-success btn-fill",
            buttonsStyling: false
          })
        }
      })
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(tableRow => tableRow.id === item.id)
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1)
      }
    },

    enableInterceptor() {
      this.axiosInterceptor = window.axios.interceptors.request.use(
        config => {
          this.isLoading = true
          return config
        },
        error => {
          this.isLoading = false
          return Promise.reject(error)
        }
      )

      window.axios.interceptors.response.use(
        response => {
          this.isLoading = false
          return response
        },
        function(error) {
          this.isLoading = false
          return Promise.reject(error)
        }
      )
    },

    disableInterceptor() {
      window.axios.interceptors.request.eject(this.axiosInterceptor)
    },
    deleteAllTestPatients() {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$store
              .dispatch("deleteAllTestPatients")
              .then(res => {
                console.log("Deletion successful.")
                this.$store.dispatch("loadScreenings", this.payload)
              })
              .catch(err => {
                console.log(err)
              })
          }
        })
    },
    deleteScreening(id) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false
        })
        .then(result => {
          if (result.value) {
            this.$store
              .dispatch("deleteScreening", id)
              .then(res => {
                console.log("Deletion successful.")
                this.$store.dispatch("loadScreenings", this.payload)
              })
              .catch(err => {
                console.log(err)
              })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
#referral {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.md-table {
  max-height: 67dvh;
  overflow: auto;
}

.md-table-cell {
  padding: 2px 8px;
  font-size: 14px;
}

.text-right ::v-deep .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}

.md-table ::v-deep .md-table-head:last-child {
  text-align: right;
}

.table-shopping {
  table > thead > tr > th {
    text-transform: uppercase;
  }

  table > thead > tr > .md-table-head .md-table-head-label {
    font-size: 0.75rem;

    b {
      display: block;
      margin-bottom: 3px;
    }
  }

  .td-name {
    font-size: 1em !important;
    line-height: 1.1;

    small {
      color: green;
      font-size: 0.77em;
    }
  }

  .td-name {
    min-width: 200px;
  }

  .td-number {
    text-align: right;
    min-width: 150px;

    small {
      margin-right: 3px;
    }
  }

  .img-container {
    width: 120px;
    max-height: 160px;
    overflow: hidden;
    display: block;

    img {
      width: 100%;
    }
  }
}

.md-table-row:hover {
  background-color: #74b5ff !important;
  color: white;
}

.table-striped {
  tbody > tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody > tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.table-selected {
  color: white;
  background-color: #005ac2 !important;

  a,
  small {
    color: white;
  }
}

.mmodal-container {
  max-width: 70vw; 
  max-height: 75vh !important; 
  overflow: auto; 

  margin: 0px auto;
  position: relative;
  background-color: #fff;
  transition: all 0.3s ease;
  box-shadow: 0 27px 24px 0 rgba(0, 0, 0, 0.2), 0 40px 77px 0 rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  border: none;
  z-index: 9999;
}

.selected-filter-item {
  color: #0041b3;
  font-weight: 500;
}

.md-table {
  cursor: pointer;
}

.dropdown {
  cursor: pointer;
}

.dropdown-menu {
  li {
    padding: 3px 3px 3px 5px;
  }

  li:hover {
    background-color: #005ac2 !important;
    color: #fff !important;
  }
}
</style>
